export enum CmImageNotFound {
	ImageNotFound = 'Image Not Found',
}
